// ===========================================================================
// SocialDistributionRow — capa social (apoyo a la decisión clínica). Pills por
// categoría global + backlog de revisión (suma de auto-sugeridos). Explícita-
// mente subordinada al costo (etiquetada "decision support").
// ===========================================================================
import React from "react";
import { Box, Paper, Typography, Stack, Chip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { SOCIAL_CATEGORY_COLORS } from "../../common/constants";

export default function SocialDistributionRow({ data }) {
  const rows = Array.isArray(data) ? data : [];
  const backlog = rows.reduce((acc, r) => acc + (Number(r.autoSuggested) || 0), 0);

  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
        <InfoOutlinedIcon fontSize="small" color="disabled" />
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Social distribution
        </Typography>
        <Chip label="Decision support" size="small" variant="outlined" sx={{ height: 18, fontSize: "0.6rem" }} />
        {backlog > 0 && (
          <Typography variant="caption" color="warning.main" sx={{ ml: "auto", fontWeight: 600 }}>
            {backlog.toLocaleString()} pending review
          </Typography>
        )}
      </Stack>

      {rows.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No data available yet.
        </Typography>
      ) : (
        <Stack direction="row" spacing={1.5} useFlexGap flexWrap="wrap">
          {rows.map((row) => {
            const color = SOCIAL_CATEGORY_COLORS[row.globalCategory] || "#9e9e9e";
            return (
              <Box
                key={row.globalCategoryKey || row.globalCategory}
                sx={{
                  px: 1.5,
                  py: 1,
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: "divider",
                  borderLeft: `4px solid ${color}`,
                  minWidth: 150,
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                  {row.globalCategory}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 800, color }}>
                  {Number(row.total || 0).toLocaleString()}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {Number(row.confirmed || 0)} confirmed · {Number(row.autoSuggested || 0)} suggested
                </Typography>
              </Box>
            );
          })}
        </Stack>
      )}
    </Paper>
  );
}
